import { compact } from '../../../../helpers/compact';
import {
  LaPosteEn4SliceType,
  ProofCategorySlice,
} from '../../../../types/page/la-poste-en-4';
import { toLink, toRichText, toText } from '../../fields';

const proofCategorySlice = (
  data: Record<string, any>
): ProofCategorySlice | undefined => {
  const title = toText(data.primary?.title);
  const theme = toText(data.primary?.theme);
  if (!title || !theme) {
    return undefined;
  }

  return compact({
    type: LaPosteEn4SliceType.PROOF_CATEGORY,
    title,
    theme,
    items: data.items.map((item: any) =>
      compact({
        icon: toText(item.icon),
        title: toText(item.title),
        description: toRichText(item.description),
        ctaLabel: toText(item.ctaLabel),
        ctaLink: toLink(item.ctaLink),
      })
    ),
  });
};

export default proofCategorySlice;
